import { MAJORS } from "@/api/queries/majors";
import { useReactiveVar, useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { majorsVar } from "@/reactiveVars/global";
import { Major } from "@/__generated__/types";

const PAGE_SIZE = 100;

export const useMajors = (): { data: Major[] | null; loading: boolean } => {
  const [getMajors] = useLazyQuery(MAJORS);
  const majorsValue = useReactiveVar(majorsVar);

  useEffect(() => {
    if (majorsValue !== null) return;

    const fetchAllItems = async () => {
      let hasNextPage = true;
      let cursor = null;
      const pages = [];

      while (hasNextPage) {
        const { data } = await getMajors({
          variables: { after: cursor, first: PAGE_SIZE },
        });
        const majorConnection = data?.majors;

        const majors =
          majorConnection?.edges
            ?.map((edge) => edge?.node)
            .filter((m) => !!m) || [];

        pages.push(majors);
        hasNextPage = !!majorConnection?.pageInfo.hasNextPage;
        cursor = majorConnection?.pageInfo.endCursor;
      }

      majorsVar(pages.flat());
    };
    fetchAllItems();
  }, [getMajors, majorsValue]);

  return { data: majorsValue, loading: majorsValue === null };
};
